<app-loader></app-loader>
<app-header></app-header>
<app-navigation></app-navigation>
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-author-controls></app-author-controls>
